import { WrapperAmplitudeCompanyPage } from "components/company/v3/WrapperCompany";
import useBrazilianBoxes from "components/company/v3/brazilian/boxes/hooks/useBrazilianBoxes";
import BrazilianPageLayout from "components/company/v3/layouts/BrazilianPageLayout";
import { CompanyMenuSlugEnum } from "components/company/v3/menu/enums";
import CompanyPageCta from "components/conversion/CompanyPageCta";
import TwoPassInViewRender from "components/shared/TwoPassInViewRender";
import classNames from "components/ui/classNames";
import useSelfie from "lib/hooks/useSelfie";
import SetHttpStatusCode from "lib/http/SetHttpStatusCode";
import getQueryStringValue from "lib/utils/getQueryStringValue";
import type { NextPage } from "next";
import NotFound from "pages/404";
import { format } from "util";

interface BrazilianDefaultPageProps {
  tickerSymbol: string | null;
}

const BrazilianDefaultPage: NextPage<BrazilianDefaultPageProps> = function BrazilianDefaultPage({ tickerSymbol }) {
  const { orderedMenu } = useBrazilianBoxes(tickerSymbol);
  const selfie = useSelfie();
  const normalizedTickerSymbol = (tickerSymbol || "").toUpperCase();

  if (!normalizedTickerSymbol || normalizedTickerSymbol.length > 8 || /^([0-9]+)$/.test(normalizedTickerSymbol)) {
    return (
      <>
        <SetHttpStatusCode httpStatus={404} />
        <NotFound />
      </>
    );
  }

  return (
    <BrazilianPageLayout tickerSymbol={normalizedTickerSymbol}>
      <WrapperAmplitudeCompanyPage category="Ações" tickerSymbol={normalizedTickerSymbol}>
        <div className="flex flex-col space-y-10 pb-6">
          {orderedMenu.map(({ slug, box }, index) => {
            if ([CompanyMenuSlugEnum.CARDS, CompanyMenuSlugEnum.ABOUT].includes(slug)) {
              return <div key={format("box/%s", slug)}>{box}</div>;
            }
            return (
              <div key={format("box/%s", slug)}>
                <TwoPassInViewRender
                  initialInView={index <= 2}
                  loadingSkeletonClassName={classNames(
                    "relative flex w-full max-w-7xl flex-col gap-6 px-4",
                    "xl:mx-auto xl:px-0",
                  )}
                  tag={slug}
                >
                  {box}
                </TwoPassInViewRender>
              </div>
            );
          })}
          {!selfie?.isPremium && <CompanyPageCta />}
        </div>
      </WrapperAmplitudeCompanyPage>
    </BrazilianPageLayout>
  );
};

BrazilianDefaultPage.getInitialProps = async ({ query }) => ({
  tickerSymbol: getQueryStringValue(query, "tickerSymbol"),
});

export default BrazilianDefaultPage;
